export const ENABLE_NOTIFICATION_COUNT_CHANGE = 'notifications/ENABLE_NOTIFICATIONS_COUNT_CHANGE';

export const enableNotificationCountChanges = enable => ({
  type: ENABLE_NOTIFICATION_COUNT_CHANGE,
  payload: enable,
});



// WEBPACK FOOTER //
// ./app/actions/enable-notifications-count-change.js